export const addresses = {
  dotNounsToken: "0xd038A2EE73b64F30d65802Ad188F27921656f28F",
};
